import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type SettingState = {
  lang: "en" | "ar";
};

const initialState: SettingState = {
  lang: "ar",
};

const settingSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {
    setLang: (state, { payload }: PayloadAction<SettingState>) => {
      state.lang = payload.lang;
    },
  },
});

export const { setLang } = settingSlice.actions;
export default settingSlice.reducer;
